import PropTypes from 'prop-types';

import usePayment from '../../../hooks/providers/usePayment';
import ContactEmailsList from '../ContactEmailsList/ContactEmailsList';

const UpgradeSubscriptionEmailsList = ({linkColor = '#90a8fc'}) => {
  const {subscriptionContactInfo} = usePayment();
  const mails = subscriptionContactInfo.split(',');
  const contactSentence = mails.length > 1 ? 'contactez un des utilisateurs suivants :' : 'contactez ';

  return (
    <span>
      Pour augmenter la limite de votre abonnement, {contactSentence} <ContactEmailsList linkColor={linkColor} />
    </span>
  );
};

UpgradeSubscriptionEmailsList.propTypes = {
  linkColor: PropTypes.string
};

export default UpgradeSubscriptionEmailsList;
